export const text = {
  Agenda: "Agenda",
  AddEventType: "Add Event Type",
  AddCalendarEvent: "Add Calendar Event",
  EventType: "Event Type",
  CalendarEvent: "Calendar Event",
  StartDateTime: "Start Date Time",
  EndDateTime: "End Date Time",
  CalendarEventaddedsuccessfully: "Calendar Event added successfully!",
  CalendarEventupdatedsuccessfully: "Calendar Event updated successfully!",
  CalendarEventDeletedsuccessfully: "Calendar Event Deleted successfully!",
  EventTypeaddedsuccessfully: "Event Type added successfully!",
  EventTypeupdatedsuccessfully: "Event Type updated successfully!",
  EventTypeDeletedsuccessfully: "Event Type Deleted successfully!",
  Entertheeventtype: "Enter the event type",
};
